/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { FieldSkeleton } from "./FieldSkeleton";
import "react-datepicker/dist/react-datepicker.css";
import { returnInputStyle } from "./TextField";
import { StyledText } from "../../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { colors } from "../../colors";
import { RefCallBack } from "react-hook-form";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  errorMessage?: string;
  innerRef?: RefCallBack | React.RefObject<HTMLInputElement>;
  helperText?: string;
  labelIcon?: React.ReactNode;
}

const floatingElementStyle = css`
  position: absolute;
  top: 50%;
  display: flex;
  right: 8px;
  text-align: center;
  transform: translate(-50%, -50%);
`;

const wrapperStyle = css`
  position: relative;
  width: 100%;
  > .react-datepicker-wrapper {
    width: 100%;
  }
`;

export const TimePickerField = ({
  label,
  errorMessage,
  helperText,
  labelIcon,
  className,
  innerRef,
  ...rest
}: Props) => {
  return (
    <FieldSkeleton
      errorMessage={errorMessage}
      helperText={helperText}
      label={label}
      labelIcon={labelIcon}
    >
      <div css={wrapperStyle}>
        <input
          css={returnInputStyle(errorMessage)}
          type="time"
          autoComplete="off"
          ref={innerRef}
          {...rest}
        />
        <StyledText
          css={floatingElementStyle}
          className="bodyTextSemibold mb-0"
          color={colors.textPrimary}
        >
          <FontAwesomeIcon icon={solid("clock")} />
        </StyledText>
      </div>
    </FieldSkeleton>
  );
};
